import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        component: 'wtBulkInsert',
        name: 'bulkInsert',
        url: '/bulkInsert',
        resolve: {
            auth: Resolve.authResolve,
            roles: Resolve.rolesResolve([Roles.superAdministrator, Roles.master, Roles.engineer, Roles.operator])
        },
        abstract: false,
        data: {
            isMobileVisible: true,
            sortingOrder: 0,
            icon: 'fa-cubes',
            displayName: 'Bulk insert',
            editRoles: [],
            editButtonVisibility: () => false
        }
    }];

export default states;